<template>
  <div>
    <el-container>
      <div class="header">
        <img src="../assets/logodi2.png" style="width: 8%;" />
        <el-menu background-color="#fff" text-color="#000" active-text-color="#f00" :default-active="activeIndex" mode="horizontal"
          router>
          <header-nav :navMenus="menuData"></header-nav>
        </el-menu>
      </div>
    </el-container>

    <router-view :key="key"></router-view>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
  import header from '../components/Header.vue';
  import footer from '../components/Footer.vue';
  import $ from 'jquery'
  export default {

    data() {
      return {
        activeIndex: 'main', //会展开name于此相同的item
        menuData: this.$router.options.routes
      }
    },
    created: function() {
      //console.log("navMenus" + JSON.stringify(this.menuData))
    },
    updated: function() {
      // debugger

      $.each($(".el-menu-item>div>span"), function(i, val) {
        if (val.innerHTML == "加盟商登录") {
          //debugger
          let vli = val.parentElement.parentElement
          $(vli).addClass("rightmenuitem")
          $(vli).prop('id', "Login");
        } else if (val.innerHTML == "登录/注册" || val.innerHTML.indexOf("欢迎:") >= 0) {
          debugger
          let vli = val.parentElement.parentElement
          $(vli).addClass("rightmenuitem")
          //$(vli).prop('id', "Login");
        }
        // alert(i);
        // alert(val);
      });
    },
    mounted() {
      //debugger
      // debugger

      $(".el-submenu").on("mouseenter", function(e) {
        // debugger
        if (e.currentTarget.innerText.indexOf("首页") < 0 && e.currentTarget.innerText.indexOf("课程中心") < 0 &&
          e.currentTarget.innerText.indexOf("向日葵商城") < 0) {
          $(".a1").html("")
        }
        if (e.currentTarget.innerText.indexOf("课程中心") >= 0) {
          $(".a1").html("")
          var img =
            "<img src='../../static/img/Home/Online.jpg' style='width: 290px; height: 290px;'>"
          $(".a1").append(img);
        } else if (e.currentTarget.innerText.indexOf("向日葵商城") >= 0) {
          $(".a1").html("")
          var img =
            "<img src='../../static/img/Home/Instrument.jpg' style='width: 290px; height: 290px;'>"
          $(".a1").append(img);
        }
      })

      $(".el-menu-item").on("mouseenter", function(e) {
        //debugger
        //  $(".el-submenu").removeClass("is-active")
        // $(e).parent().addClass("is-active")
        // var c= $(".is-active")

        if (e.currentTarget.innerText.indexOf("购物车") >= 0) {
          $(".a1").html("")
          return false
        }
        if (e.currentTarget.innerText.indexOf("我的课程") >= 0) {
          $(".a1").html("")
          return false
        }
        if (e.currentTarget.innerText.indexOf("我的订单") >= 0) {
          $(".a1").html("")
          return false
        }
        //var cc=$(this).attr('data')
        $(".a1").html("")
        if (e.currentTarget.innerText.indexOf("网络课程") >= 0) {
          var img =
            "<img src='../../static/img/Home/Online.jpg' style='width: 290px; height: 290px;'>"

          $(".a1").append(img);
        } else if (e.currentTarget.innerText.indexOf("线下课程") >= 0) {
          var img =
            "<img src='../../static/img/Home/Offline.png' style='width: 290px; height: 290px;'>"

          $(".a1").append(img);
        } else if (e.currentTarget.innerText.indexOf("乐器商城") >= 0) {
          var img =
            "<img src='../../static/img/Home/Instrument.jpg' style='width: 290px; height: 290px;'>"
          $(".a1").append(img);
        } else if (e.currentTarget.innerText.indexOf("图书及周边商城") >= 0) {
          var img =
            "<img src='../../static/img/Home/Books.jpg' style='width: 290px; height: 290px;'>"
          $(".a1").append(img);
        }
      })
      this.init()
    },
    components: {
      headerNav: header,
      footerNav: footer,
    },
    computed: {

      key() {
        //debugger
        return this.$route.fullPath
      }
    },
    methods: {
      init() {
        // debugger
        var c = $(".el-menu--popup")
        var d = $(".el-menu--popup>div")
        d.addClass("left")
        var boarddiv =
          "<div class='a1' style='float: left;'><img src='http://www.xiaoyezi.com/imgs/index_site/prolist6.png' style='width: 290px; height: 250px;'/></div>";
        c.append(boarddiv);
        //$(".el-menu-item").on("mouseleave",mouset)
      },
    },
    watch: {
      '$route': function(newUrl, oldUrl) {
        // debugger
        let start = window.location.href.lastIndexOf('/');
        let path = window.location.href.slice(start + 1);
        switch (path) {
          case "Offline":
            this.activeIndex = path;
            break;
          case "Online":
            this.activeIndex = path;
            break;
          case "Instrument":
            this.activeIndex = path;
            break;
          case "Books":
            this.activeIndex = path;
            break;
          case "shoppingcart":
            this.activeIndex = path;
            break;
          case "CoursewareList":
            this.activeIndex = path;
            break;
          case "myorder":
            this.activeIndex = path;
            break;
        }

        //this.$router.go(0);
        //this.appKey=new Date().getTime();
      }
    },
  }
</script>

<style>
  .header {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
   /* justify-content: center; */
   margin-left:11.2%;
    padding: 0;
  }

  body {
    font: 12px/1.5 tahoma, arial, "Hiragino Sans GB";
    font-family: "PingFang SC", Helvetica, "思源黑体 CN Normal", Tahoma, Arial, DengXian, "Microsoft YaHei", Simsun, SimHei, sans-serif;
  }

  .Main {
    font: 12px/1.5 tahoma, arial, 'Hiragino Sans GB', '\5b8b\4f53', sans-serif;
  }

  header {
    padding: 0 !important;
  }

  button:hover {
    cursor: pointer;
  }

  .el-menu--horizontal>div>.el-submenu {
    float: left;
  }

  .el-menu--horizontal>div>.el-menu-item {
    float: left;
    height: 60px !important;
    line-height: 60px !important;
    margin: 0 !important;
    border-bottom: 2px solid transparent !important;
    color: #909399;
  }

  .el-menu--horizontal>div>.el-submenu .el-submenu__icon-arrow {
    position: static;
    vertical-align: middle;
    margin-left: 8px !important;
    margin-top: -3px !important;
  }

  .left {
    float: left;
  }

  #Login {
    color: #FFF !important;
    margin-left: 20px !important;
    background: #ef7b42 !important;
    height: 35px !important;
    display: inline-block;
    line-height: 35px !important;
    padding: 0 5px;
    border-radius: 50%;
    font-weight: bold;
    margin-top: 1.1% !important;
  }

  .el-menu-item {
    font-size: 16px !important;
  }

  .el-submenu__title {
    font-size: 16px !important;
  }

  li::before {
    content: '';
    width: 24px;
    height: 4px;
    border-radius: 10px;
    background-color: #f54f50;
    position: absolute;
    bottom: 12px;
    left: 50%;
    margin-left: -12px;
    transform: scale(0);
    transition: all ease .1s;
  }

  .content-title {
    display: inline-block;
    margin: 0 auto;
    line-height: 54px;
    text-align: center;
    font-size: 40px;
    color: #f54f50;
    font-weight: 700;
    margin-top: 5%;
  }

  .content-device-line {
    /* width: 10%;
   height: 8px;
   margin: 0 auto;
   border-radius: 4px;
   background-color: #FF6F61;
   float: left;
   margin-left: 1%; */
    width: 110px;
    height: 8px;
    border-radius: 4px;
    background-color: #f54f50;
    margin-left: 25px;
    margin-top: 10px;
  }

  .rightmenuitem {
    left: 10vw !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout.vue